/**
 * Default Home page content. The CMS stores overrides in the `home` page row;
 * anything missing falls back to these values.
 */
export const HOME_SECTION_TYPES = {
  tools: { label: 'Featured tools', icon: 'fas fa-wrench', hasCount: true },
  updates: { label: 'Tool updates', icon: 'fas fa-code-branch', hasCount: true },
  videos: { label: 'Videos', icon: 'fab fa-youtube', hasCount: true },
  reviews: { label: 'Reviews', icon: 'fas fa-star', hasCount: true },
  cta: { label: 'Call to action', icon: 'fas fa-bullhorn', hasCount: false },
};

export const HOME_PLATFORMS = {
  twitch: 'Twitch',
  youtube: 'YouTube',
  kick: 'Kick',
};

export const HOME_BUTTON_STYLES = ['twitch', 'youtube', 'primary', 'secondary'];

export function defaultHomeContent() {
  return {
    hero: {
      title: 'Free Tools and',
      highlight: 'Overlays',
      platformsPrefix: 'for',
      platforms: ['twitch', 'youtube', 'kick'],
      subtitle: '',
      buttons: [
        { label: 'Browse tools', href: '/tools', icon: 'fas fa-wrench', style: 'primary' },
        { label: 'Watch live', href: 'https://twitch.tv/zemaxi', icon: 'fab fa-twitch', style: 'twitch' },
      ],
      showTicker: true,
    },
    sections: [
      {
        id: 'tools',
        enabled: true,
        eyebrow: '// FEATURED_TOOLS',
        heading: 'Featured',
        highlight: 'Tools',
        intro: '',
        count: 7,
      },
      {
        id: 'updates',
        enabled: true,
        eyebrow: '// CHANGELOG',
        heading: 'Latest',
        highlight: 'Updates',
        intro: 'New tools, new features and fixes, straight from the workbench.',
        count: 5,
      },
      {
        id: 'videos',
        enabled: true,
        eyebrow: '// LATEST_UPLOADS',
        heading: 'Latest',
        highlight: 'Videos',
        intro: 'Tool showcases, setup guides and gameplay from the channel.',
        count: 5,
      },
      {
        id: 'reviews',
        enabled: true,
        eyebrow: '// GAME_LOG',
        heading: 'Latest',
        highlight: 'Reviews',
        intro: '',
        count: 3,
      },
      {
        id: 'cta',
        enabled: true,
        eyebrow: '// JOIN_THE_NODE',
        heading: 'Come hang out',
        highlight: 'live',
        intro: 'Tools get built, tested and broken on stream. Drop in, ask questions, suggest the next one.',
        buttons: [
          { label: 'Follow on Twitch', href: 'https://twitch.tv/zemaxi', icon: 'fab fa-twitch', style: 'twitch' },
          { label: 'Support on Ko-fi', href: 'https://ko-fi.com/zemaxi', icon: 'fas fa-mug-hot', style: 'secondary' },
        ],
      },
    ],
  };
}

/**
 * Merge stored content over the defaults, section by section, so new default
 * sections appear even when the stored list predates them.
 */
export function mergeHomeContent(stored) {
  const defaults = defaultHomeContent();
  if (!stored || typeof stored !== 'object') {
    return defaults;
  }
  const storedSections = Array.isArray(stored.sections) ? stored.sections : [];
  const sections = storedSections
    .filter((section) => HOME_SECTION_TYPES[section?.id])
    .map((section) => ({ ...defaults.sections.find((d) => d.id === section.id), ...section }));
  defaults.sections.forEach((section) => {
    if (!sections.some((s) => s.id === section.id)) {
      sections.push(section);
    }
  });
  return {
    hero: { ...defaults.hero, ...(stored.hero || {}) },
    sections,
  };
}
